import { useNavigate } from 'react-router-dom';
import { Sensitive } from '../Sensitive';
import { Trophy } from 'lucide-react';

function Avatar({ src, name }) {
  if (src) {
    return <img src={src} alt={name} className="h-10 w-10 shrink-0 rounded-full object-cover" />;
  }
  const initials = (name || '?')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join('');
  return (
    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#3B82F6] to-[#2563EB] text-xs font-bold text-white">
      {initials}
    </div>
  );
}

export const LeaderboardCard = ({ leaderboard, loading }) => {
  const navigate = useNavigate();
  const maxAp = Math.max(...(leaderboard || []).map((a) => a.issued_ap || 0), 1);

  return (
    <div
      className="rounded-[20px] bg-white p-6 shadow-[0px_18px_40px_rgba(112,144,176,0.12)]"
      data-testid="leaderboard-widget"
    >
      <div className="mb-5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-50">
            <Trophy className="h-5 w-5 text-amber-500" strokeWidth={2} />
          </div>
          <div>
            <h3 className="font-['Manrope'] text-lg font-bold text-[#2B3674]">Top Producers</h3>
            <p className="text-xs text-[#A3AED0]">Month-to-date by Issued AP</p>
          </div>
        </div>
        <button
          onClick={() => navigate('/production')}
          data-testid="view-leaderboard-button"
          className="rounded-full bg-[#F4F7FE] px-3 py-1.5 text-xs font-semibold text-[#2B3674] transition-colors hover:bg-[#E9EDF7]"
        >
          View all
        </button>
      </div>

      {loading ? (
        <div className="py-10 text-center">
          <div className="mx-auto h-6 w-6 animate-spin rounded-full border-2 border-[#2447D6] border-t-transparent" />
        </div>
      ) : !leaderboard || leaderboard.length === 0 ? (
        <div className="py-10 text-center" data-testid="leaderboard-empty-state">
          <Trophy className="mx-auto mb-2 h-10 w-10 text-[#E9EDF7]" />
          <p className="text-sm text-[#A3AED0]">No production data this month</p>
        </div>
      ) : (
        <div className="space-y-4">
          {leaderboard.slice(0, 5).map((agent, index) => (
            <div
              key={agent.agent_id}
              className="flex items-center gap-3"
              data-testid={`leaderboard-row-${index}`}
            >
              <span className="w-4 shrink-0 text-center text-sm font-bold text-[#A3AED0]">
                {index + 1}
              </span>
              <Avatar src={agent.profile_picture} name={agent.agent_name} />
              <div className="min-w-0 flex-1">
                <div className="flex items-baseline justify-between gap-2">
                  <p className="truncate text-sm font-bold text-[#2B3674]">{agent.agent_name}</p>
                  <p className="shrink-0 text-sm font-bold text-[#2B3674]">
                    <Sensitive>${Math.round(agent.issued_ap || 0).toLocaleString()}</Sensitive>
                  </p>
                </div>
                <div className="mt-1.5 flex items-center gap-2">
                  <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-[#E9EDF7]">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-[#2447D6] to-[#3B82F6] transition-all duration-700"
                      style={{ width: `${Math.max(((agent.issued_ap || 0) / maxAp) * 100, 4)}%` }}
                    />
                  </div>
                  <span className="shrink-0 rounded-full bg-green-50 px-1.5 py-0.5 text-[10px] font-semibold text-[#01B574]">
                    {agent.policy_count || 0} {(agent.policy_count || 0) === 1 ? 'policy' : 'policies'}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
